import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { Chatbot } from "@/components/layout/Chatbot";
import { NoiseOverlay } from "@/components/layout/NoiseOverlay";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export function Layout() {
  return (
    <ReactLenis root options={{ lerp: 0.1, smoothWheel: true }}>
      <ScrollToTop />
      <NoiseOverlay />
      <Navbar />
      <main className="min-h-screen bg-black">
        <Outlet />
      </main>
      <Footer />
      <Chatbot />
    </ReactLenis>
  );
}
